module.exports = __webpack_public_path__ + "img/Spain.66a2c619.png";